import { GAME_CONFIG, LLM_CONFIG, ModelConfig } from '../../config';
import { SceneData, LLMResponse } from '../../types';
import { BaseLLMAdapter } from './BaseLLMAdapter';
import { ResponseProcessor } from '../../processors/response';

/**
 * 默认LLM适配器实现，处理通用模型
 */
export class DefaultAdapter extends BaseLLMAdapter {
  private responseProcessor: ResponseProcessor;
  
  /**
   * 构造函数
   * @param config 模型配置
   * @param debugMode 是否处于调试模式
   */
  constructor(config: ModelConfig, debugMode: boolean = false) {
    super(config, debugMode);
    this.responseProcessor = new ResponseProcessor(debugMode);
  }
  
  /**
   * 准备默认请求
   */
  async prepareRequest(prompt: string): Promise<{
    endpoint: string;
    headers: Headers;
    body: any;
  }> {
    const endpoint = this.getEndpoint();
    const headers = this.createBaseHeaders();
    
    // 构建请求体
    const body = this.createBaseBody(prompt);
    
    // 添加系统消息
    body.messages.unshift(this.createSystemMessage(
      "你是一个赛博朋克2077风格游戏世界的创造者和叙事者。这是一个充满高科技和低生活的世界，霓虹与阴影并存，义体与人性交织。"
    ));
    
    this.logDebug('默认请求详情:', {
      endpoint,
      model: this.config.id,
      headers: Array.from(headers.entries()),
      body
    });
    
    return { endpoint, headers, body };
  }
  
  /**
   * 处理响应
   */
  async processResponse(response: Response): Promise<SceneData | null> {
    try {
      const data = await response.json() as LLMResponse;
      
      this.logDebug('模型原始响应:', data);
      
      return this.responseProcessor.processResponse(data);
    } catch (error) {
      console.error('处理响应时出错:', error);
      throw error;
    }
  }
} 